import React from 'react';
import PropTypes from 'prop-types';
import QvrfComponent from 'components/common/Qlik/QvrfComponent';
import QvrfContainer from 'components/qvrf_component/QvrfContainer';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { addVisualisation } from 'redux/active/actions';

const QlikColumn = ({ qsOptions, object, height }) => {
    const { id } = useParams();
    const dispatch = useDispatch();

    const _addVisualisation = (payload) => {
        dispatch(addVisualisation(payload));
    };

    return (
        <QvrfContainer config={qsOptions.config} loaderHeight={height}>
            <QvrfComponent
                options={qsOptions}
                type={object.type}
                props={{
                    type: 'table',
                    id: object.qsId,
                    height: height,
                    exportData: object.exportData === 'enabled',
                    exportDataOptions: { format: 'OOXML', state: 'P' },
                }}
                pageId={id}
                addVisualisation={_addVisualisation}
            />
        </QvrfContainer>
    );
};

QlikColumn.propTypes = {
    qsOptions: PropTypes.object.isRequired,
    object: PropTypes.object.isRequired,
    height: PropTypes.number,
};

export default QlikColumn;
